import React, { useEffect } from 'react';
import { useParams } from 'react-router-dom';
import Paper from '@mui/material/Paper';
import Grid from '@mui/material/Grid';
import Skeleton from '@mui/material/Skeleton';
import  styled from '@emotion/styled';
import { useAppSelector, useAppDispatch } from '../../../redux/hook';
import Map from '../../maps/Map';
import { LatLng } from 'leaflet';
import { fetchScanSessionBySessionId } from '../../../redux/slices/scanSessionSlice';
import { Coordinates } from '../../../types/Coordinates';
import {useTheme} from "@mui/material";

export default function ScanDetail() {
  const theme = useTheme();
  const Item = styled(Paper)`
    background-color: ${theme.palette.mode === 'dark' ? '#1A2027' : '#fff'};
    ...theme.typography.body2;
    padding: ${theme.spacing(1)};
    text-align: center;
    color: ${theme.palette.text.secondary};
  `
  const { scanSessionId } = useParams();
  const [activeRightTab, setActiveRightTab] = React.useState('nearreader');
  const [activeBottomTab, setBottomActiveTab] = React.useState('1');

  const scanSessionState = useAppSelector((state) => state.scanSession);
  const readerReportState = useAppSelector((state) => state.readerReports);
  const facilitiesState = useAppSelector((state) => state.facilities);
  const dispatch = useAppDispatch();

  useEffect(() => {
    if (scanSessionId) dispatch(fetchScanSessionBySessionId(scanSessionId));
  }, [scanSessionId]);

  //   const handleRightTabchange = (event: React.SyntheticEvent, newValue: string) => {
  //     dispatch(updateEditingMapState(newValue === 'configurations'));
  //     setActiveRightTab(newValue);
  //   };
  //   const handleBottomTabchange = (event: React.SyntheticEvent, newValue: string) => setBottomActiveTab(newValue);
  //   const handleConfigUpdated = (emei) => {
  //     dispatch(fetchReaderByEmei(emei));
  //   };

  let positions: Coordinates[] = [];
  let centerMap = new LatLng(0, 0);

  return (
    <React.Fragment>
      <Grid container spacing={0.5} style={{ paddingTop: 5 }}>
        <Grid item xs={12} sm={6} lg={5}>
          <Item>
            {scanSessionState.scanSession ? (
              <Map
                //
                center={centerMap}
                coordinates={positions}
              />
            ) : (
              <Skeleton animation='wave' variant='circular' width={40} height={40}></Skeleton>
            )}
          </Item>
        </Grid>
        <Grid item xs={12} sm={6} lg={7}>
          <Item>
            {/* <TabContext value={activeRightTab}>
              <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
                <TabList onChange={handleRightTabchange} aria-label='lab API tabs example'>
                  <Tab label='Near Readers' value='nearreader' sx={{ textTransform: 'none' }} />
                  <Tab label='Facilities' value='facilities' sx={{ textTransform: 'none' }} />
                  <Tab label='Configuration' value='configurations' sx={{ textTransform: 'none' }} />
                </TabList>
              </Box>
              <TabPanel value='nearreader' style={{ height: '630px' }}>
                {readerState.reader ? (
                  <NearReaders reader={readerState?.reader} />
                ) : (
                  <Skeleton animation='wave' variant='circular' width={40} height={40}></Skeleton>
                )}
              </TabPanel>
              <TabPanel value='facilities' style={{ height: '630px' }}>
                {readerState?.reader && <Facilities reader={readerState?.reader} />}
              </TabPanel>
              <TabPanel value='configurations' style={{ height: '630px' }}>
                {readerState?.reader && <ReaderConfiguration reader={readerState?.reader} onUpdated={handleConfigUpdated} />}
              </TabPanel>
            </TabContext> */}
          </Item>
        </Grid>
        {/* device */}
        <Grid item xs={12}>
          <Item>
            {/* <TabContext value={activeBottomTab}>
              <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
                <TabList onChange={handleBottomTabchange} aria-label='lab API tabs example'>
                  <Tab label='Reader Report' value='1' sx={{ textTransform: 'none' }} />
                  <Tab label='Logs' value='2' sx={{ textTransform: 'none' }} />
                </TabList>
              </Box>
              <TabPanel value='1' style={{ height: '100vh', display: 'contents' }}>
                {readerState?.reader && <ReaderReports reader={readerState?.reader} />}
              </TabPanel>
              <TabPanel value='2' style={{ height: '100vh', display: 'contents' }}>
                {readerState?.reader && <ReaderLogs reader={readerState?.reader} />}
              </TabPanel>
            </TabContext> */}
          </Item>
        </Grid>
      </Grid>
    </React.Fragment>
  );
}
